// WEB FILE -> see .native file if ios/android does not work

import { getAuthToken } from "@provider/token";

export async function writeUrlAsFile({
  url,
  fileName,
  withToken,
}: {
  url: string;
  fileName: string;
  withToken: boolean;
}): Promise<boolean> {
  try {
    let finalUrl = url;

    if (withToken) {
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      });

      if (res.status !== 200) {
        return false;
      }
      const blob = await res.blob();

      finalUrl = window.URL.createObjectURL(blob);
    }

    const link = document.createElement("a");
    link.href = finalUrl;
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.log("download error", error);
    return false;
  }
  return true;
}
